import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { departmentsAndCentraOverviewApi } from './departmentsAndCentraOverviewApi'

export type DepartmentOrCentrumOverviewState = AsyncState<DepartmentOrCentrum[]>

export type DepartmentOrCentrum = {
  id: number
  title: string
  intro: string
  url: string
}

export const initialDepartmentOrCentrumOverviewState = loadingAsyncState(() => departmentsAndCentraOverviewApi())
